module.exports = "/integrations/components/integrationIssues/index-c9866a.html";